// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__BdSVY","center":"styles_center__gnR_y","left":"styles_left__2ASes"};